import styled, { createGlobalStyle } from "styled-components/macro";

export const HistoryAnimations = createGlobalStyle`
  @keyframes historyFadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

export const StyledFlexContainer = styled.div`
  display: flex;

  &.sw2 {
    padding: 0 10px;
  }

  button {
    margin-bottom: 16px !important;
    &:first-child {
    margin-right: 13px;
      &.secondary {
        background-color: transparent !important;
        border: 2px solid var(--primary-cta);
        color: var(--primary-cta) !important;
        padding: 10px 20px;
        svg {
          path {
            fill: var(--primary-cta);
          }
        }
        &.high-contrast {
          border: 2px solid var(--primary-cta-high-contrast) !important;
          color: var(--primary-cta-high-contrast) !important;
          svg {
            path {
              fill: var(--primary-cta-high-contrast);
            }
          }
        }
      }
    }
  }
`;
